let revision = 0;
let signedIn = false;
export function sessionState() { return { revision, signedIn }; }
export function changeSession(active) { signedIn = active; revision++; }
export function clearLegacySession() {
  for (const storage of [localStorage, sessionStorage]) {
    storage.removeItem('scheduler_token'); storage.removeItem('scheduler_user');
  }
}
